import { render } from "./TableVideos.vue?vue&type=template&id=129ac02f&scoped=true"
import script from "./TableVideos.vue?vue&type=script&lang=js"
export * from "./TableVideos.vue?vue&type=script&lang=js"

import "./TableVideos.vue?vue&type=style&index=0&id=129ac02f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-129ac02f"]])

export default __exports__